module.exports = __webpack_public_path__ + "img/paydue.d89edf9b.svg";